import axios from 'axios';
import {getHeader} from './user_api';
import {INSPECTION_API_URL} from "../constants/api_routes";

export const changeInspectionStatus = async (URL, formdata) => {
    try {
        await axios.post(`${URL}/update_status`, formdata, {headers: getHeader()});
        return ({
            success: true,
            statusMessage: "Inspection Status Changed Successfully"
        });

    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const turnDownJob = async (URL, formdata) => {
    try {
        await axios.post(`${URL}/turn_down_job`, formdata, {headers: getHeader()});
        return ({
            success: true,
            statusMessage: "Inspection Status Changed Successfully"
        });

    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const assignJobToUser = async (URL, formData) => {
    try {
        await axios.post(`${URL}/assign`, formData, {headers: getHeader()});
        return ({
            success: true,
            statusMessage: "Successfully Assigned User"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getInspectionByDate = async (URL, startDate, endDate) => {
    try {
        const res = await axios.get(`${URL}/list?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getInspectionByAddress = async (URL, address) => {
    try {
        const res = await axios.get(`${URL}/address?&address=${encodeURIComponent(address)}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getInspectionsByParams = async (URL,inspectionIds) => {
    try {
        const res = await axios.get(`${URL}/list?inspection_ids=${inspectionIds}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const createInspection = async (URL, formData) => {
    try {
        const res = await axios.post(`${URL}/create`, formData, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            error: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const updateInspectionWithAdditionalDetails = async (URL, formData) => {
    try {
        const res = await axios.put(`${URL}/additional_details`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Successfully Uploaded!!!"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getInspectionHistory = async (URL, propertyId) => {
    try {
        const res = await axios.get(`${URL}/history?property_id=${propertyId}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getInspectionByInspectionId = async (inspectionId) => {
    try {
        const res = await axios.get(`${INSPECTION_API_URL}/detail?id=${inspectionId}`, {headers: getHeader()});
        return ({
            success: true,
            inspection: res.data
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const duplicateAbortedInspection = async (formData) => {
    try {
        const res = await axios.post(`${INSPECTION_API_URL}/duplicate_inspection`,formData, {headers: getHeader()});
        return ({
            success: true,
            inspection: res.data
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.data.error
        });
    }
};

export const editInspectionDateByAgent = async (formData) => {
    try {
        const res = await axios.post(`${INSPECTION_API_URL}/agent_edit`,formData, {headers: getHeader()});
        return ({
            success: true,
            inspection: res.data
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.data.error
        });
    }
};

export const updateInspectionByID = async (URL, inspectionId,formData) => {
    try {
        const res = await axios.put(`${URL}/${inspectionId}`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Successfully Uploaded!!!"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const removeInspectionAttachment = async (URL, attachmentId) => {
    try {
        const res = await axios.post(`${URL}/delete_attachment`, {attachment_id:attachmentId}, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Delete Success!!!"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getAdditionalInspectionImages = async (inspection_id) => {
    try {
        const response = await axios.get(`${INSPECTION_API_URL}/images?inspection_id=${inspection_id}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};
export const getAdditionalVisitImages = async (pv_id) => {
    try {
        const response = await axios.get(`${INSPECTION_API_URL}/images?pv_id=${pv_id}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const uploadAdditionalImage = async (formData) => {
    let res = {}
    try {
        res = await axios.post(`${INSPECTION_API_URL}/upload_additional_images`, formData , { headers: getHeader() });
        return ({
            success:true,
            statusMessage:"Image Added Successfully!",
            id:res.data.id,
            file:res.data.file
        })
    }
    catch (error) {
        return ({
            success:false,
            statusMessage:res.error,
            error:error
        })
    }
}

export const deleteAdditionalImage = async (paramDel) => {
    let res ={};
    try {
        res = await axios.post(`${INSPECTION_API_URL}/delete_additional_images` ,paramDel, { headers: getHeader() });
        return ({
            success:true,
            statusMessage:"Image Removed Successfully!"
        })

    } catch (error){
        return ({
            success:false,
            statusMessage:res.error
        })
    }
};

export const deleteAllAdditionalImages = async (paramDel) => {
    let res ={};
    try {
        res = await axios.post(`${INSPECTION_API_URL}/delete_all_additional_images` , paramDel, { headers: getHeader() });
        return ({
            success:true,
            statusMessage:"Images Removed Successfully!"
        })

    } catch (error){
        return ({
            success:false,
            statusMessage:res.error
        })
    }
};



// WEBPACK FOOTER //
// ./src/data/inspection_api.js